import { CustomEventDispatcher } from "./event-helper"
import { TimerPender } from "./penders"

type ScrollHelperEventMap = {
    "scrolltop": void,
}

export class ScrollHelper extends CustomEventDispatcher<ScrollHelperEventMap> {
    #timer: TimerPender
    #scrolling = false
    #endPromises : (() => void)[] = []
    constructor(public readonly element: HTMLElement, timeout = 100) {
        super()
        this.#timer = new TimerPender(timeout)
        element.addEventListener("scroll", this.#scrollEvt)
    }

    #scrollEvt = (evt: Event) => this.#scroll(evt)
    #scroll(evt: Event) {
        if (this.element.scrollTop === 0) {
            this.dispatch("scrolltop")
        }
        if (this.#scrolling === false) {
            this.#scrolling = true
            this.#scrollStarted(true)
        }
        this.#timer.overwrite(() => {
            if (this.#scrolling === true) {
                this.#scrolling = false
                this.#scrollEnded()
            }
        })
    }

    /**
     * 
     * @param natural true if the scroll was started naturally by user, false if by {@link this.scrollTo}
     */
    #scrollStarted(natural : boolean) {
        //
    }

    /**
     * Called when the scroll finished
     */
    #scrollEnded() {
        while (this.#endPromises.length) {
            this.#endPromises.shift()?.()
        }
    }

    get scrolling() {
        return this.#scrolling
    }

    /**
     * Async version of scrollTo
     * @param options
     * @returns
     */
    scrollTo(options: ScrollToOptions = {}) {
        this.#scrolling = true
        this.#scrollStarted(false)
        this.element.scrollTo(options)
        return new Promise<void>((res, rej) => {
            this.#endPromises.push(res)
        })
    }

    destroy() {
        this.element.removeEventListener("scroll", this.#scrollEvt)
    }
}
